import * as yup from 'yup';


export const addRaterByEmailFormValidation = (
  invalidEmailMsg: string,
  nameRequiredMsg: string,
  requiresNameToAdd: boolean,
) => yup.object().shape(
  {
    firstName: requiresNameToAdd
               ? yup
                   .string()
                   .required(nameRequiredMsg)
               : yup
                 .  string(),
    lastName:  requiresNameToAdd
               ? yup
                   .string()
                   .required(nameRequiredMsg)
               : yup
                   .string(),
    email:     yup
                 .string()
                 .email(invalidEmailMsg)
                 .required(invalidEmailMsg),
    levelId:   yup
                 .number()
                 .positive()
                 .required(),
  },
);

export const editRaterWithNamesFormValidation = (
  invalidEmail: string,
) => yup.object().shape(
  {
    firstName:  yup
                  .string(),
    lastName:   yup
                  .string(),
    email:      yup
                  .string()
                  .email(invalidEmail),
    levelId:    yup
                  .number()
                  .positive(),
    languageId: yup
                  .number()
                  .positive(),
  },
);

export const editRaterFormValidation = (
  invalidEmail: string,
) => yup.object().shape(
  {
    email:      yup
                  .string()
                  .email(invalidEmail),
    levelId:    yup
                  .number()
                  .positive(),
    languageId: yup
                  .number()
                  .positive(),
  },
);


export const customizeMessageFormValidation = yup.object().shape(
  {
    customText: yup.string(),
  },
);
